module.exports = __webpack_public_path__ + "img/5.a42109c5.png";